import _ from 'lodash'

export interface ConfigMap {
    [key: string]: ValidValue;
}

let config: ConfigMap = {}
let loaded = false
const CONFIG_KEY = 'app.config'

type ValidValue = string | number | boolean | ValidValue[] | { [key: string]: ValidValue } | null | any
type Modifier = (value: ValidValue, key: string) => any

/**
 * Lista de modificadores registrados
 */
const modifiers: { [key: string]: Modifier } = {}

export function addModifier(key: string, modifier: Modifier) {
    modifiers[key] = modifier
}

/**
 * Carga en memoria el objeto de configuración almacenado
 */
export function load() {
    config = JSON.parse(
        localStorage.getItem(CONFIG_KEY) || '{}'
    )

    loaded = true

    return config
}

/**
 * Obtiene un parámetro de configuración
 *
 * @param key
 * @param _default
 * @param modifier
 */
export function get<T = ValidValue>(key: string, _default: ValidValue = null, modifier?: Modifier): T {
    !loaded && load()
    const value = _.get(config, key, _default)
    const m = modifier || modifiers[key] || null

    return modifier ? modifier(value, key) : value
}

/**
 * Establece el valor de un parámetro en el objeto de configuración
 *
 * @param key
 * @param value
 */
export function set(key: string, value: ValidValue) {
    _.set(config, key, value)
}

/**
 * Persiste los cambios realizados en el objeto de configuración
 */
export function flush() {
    localStorage.setItem(CONFIG_KEY, JSON.stringify(config))
}

/**
 * Guarda un parámetro de configuración y envía el objeto actualizado
 * al almacenamiento
 *
 * @param key
 * @param value
 */
export function insert(key: string, value: ValidValue) {
    set(key, value)
    flush()
}

/**
 * Retorna una copia del objeto de configuración
 */
export function copy (): ConfigMap {
    const c: ConfigMap = {}

    Object.keys(config).forEach((key) => {
        const old = config[key]

        c[key] = key in modifiers ? modifiers[key](old, key) : old
    })

    return c
}

export function replace (newConfig: ConfigMap) {
    config = newConfig
    flush()
}

export function reset () {
    config = {}
    flush()
}
